import "moment/locale/es";
import "react-datepicker/dist/react-datepicker.css";

import * as Sentry from "@sentry/react";

import { ChakraProvider } from "@chakra-ui/react";
import { loadStripe } from "@stripe/stripe-js";
import es from "date-fns/locale/es";
import moment from "moment";
import moment_timezone from "moment-timezone";
import React from "react";
import { registerLocale } from "react-datepicker";
import { createRoot } from "react-dom/client";
import App from "./App";
import { ENV } from "./constants/environment.base";
import theme from "./theme";

moment_timezone.tz.setDefault("Atlantic/Canary");
moment.locale("es");
registerLocale("es", es);

export const stripePromise = loadStripe(ENV.STRIPE_KEY, {
  locale: "es-ES",
});

Sentry.init({
  dsn: "",
  integrations: [
    new Sentry.BrowserTracing({
      // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
      tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
    }),
    new Sentry.Replay(),
  ],
  // Performance Monitoring
  tracesSampleRate: 1.0, // Capture 100% of the transactions, reduce in production!
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

const root = createRoot(document.getElementById("root") as HTMLElement);

root.render(
  <React.StrictMode>
    <ChakraProvider theme={theme}>
      <App />
    </ChakraProvider>
  </React.StrictMode>
);
